var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
// import * as JSONH from 'jsonh/js/jsonh';
import { ToastrService } from 'ngx-toastr';
import { AppSettings } from './../app.settings';
import { AuthTokenService } from './auth-token.service';
var CommonRequestService = /** @class */ (function () {
    // private defaultHttp: AuthHttp;
    // private alternativeHttp: Http;
    function CommonRequestService(injector, http, tokenService
    // private http: Http,
    // private authHttp: AuthHttp
    ) {
        var _this = this;
        this.http = http;
        this.tokenService = tokenService;
        this.layerNotFoundErr = 'Layer replaced or deleted!';
        setTimeout(function () {
            _this.toastr = injector.get(ToastrService);
        });
        // this.defaultHttp = this.authHttp;
        // this.alternativeHttp = this.http;
    }
    CommonRequestService.prototype.handleHttpRsp = function (rsp) {
        var payload = rsp.payload;
        var result = {
            data: null
        };
        for (var prop in payload) {
            if (prop !== 'type' && prop !== 'content') {
                result[prop] = payload[prop];
            }
        }
        // if (payload.data.type === 'jsonh') {
        // 	result.data = JSONH.unpack(rsp.content);
        // } else if (rsp.type === 'json') {
        // 	result.data = rsp.content;
        // } else {
        // 	result.data = rsp;
        // }
        return result;
    };
    CommonRequestService.prototype.handleError = function (err) {
        console.log(err);
        if (err.status === 400) {
            // this.toastr.error(err.message);
        }
        else if (err.status === 500) {
            var errorDetail = err.error.errorDetail;
            // Hard coded
            if (errorDetail === this.layerNotFoundErr) {
                this.handleLayerNotFoundErr();
            }
            else {
                // this.toastr.error(errorDetail);
            }
        }
        return Observable.throw(err);
    };
    // requestGet(url: string, options?: RequestOptionsArgs, successCallback?: (d: SuccessResponse<any>) => any, errorCallback?, notDefaultHttp?: boolean) {
    CommonRequestService.prototype.requestGet = function (url, options, successCallback, errorCallback, skipAuth) {
        var _this = this;
        // const requester: Http | AuthHttp = notDefaultHttp ? this.alternativeHttp : this.defaultHttp;
        options = options || {};
        if (!skipAuth) {
            if (!options.headers) {
                var headers = new HttpHeaders({
                    Authorization: this.tokenService.getToken()
                });
                options.headers = headers;
            }
        }
        return this.http.get(url, options)
            .map(function (rsp) { return _this.handleHttpRsp(rsp); })
            .catch(function (err) { return _this.handleError(err); })
            .subscribe(function (data) {
            if (successCallback) {
                successCallback(data);
            }
        }, function (err) {
            if (errorCallback) {
                errorCallback(err);
            }
        });
    };
    CommonRequestService.prototype.requestPost = function (url, body, successCallback, errorCallback, notDefaultHttp, options) {
        var _this = this;
        // const requester = notDefaultHttp ? this.alternativeHttp : this.defaultHttp;
        // options = options ? options : new RequestOptions();
        return this.http.post(url, body, options)
            .map(function (rsp) { return _this.handleHttpRsp(rsp); })
            .catch(function (err) { return _this.handleError(err); })
            .subscribe(function (data) {
            if (successCallback) {
                successCallback(data);
            }
        }, function (err) {
            if (errorCallback) {
                errorCallback(err);
            }
        });
    };
    CommonRequestService.prototype.requestPut = function (url, body, successCallback, errorCallback, notDefaultHttp, headers) {
        var _this = this;
        // const requester = notDefaultHttp ? this.alternativeHttp : this.defaultHttp;
        return this.http.put(url, body, {
            headers: headers ? headers : new HttpHeaders({ 'Content-Type': 'application/json' })
        })
            .map(function (rsp) { return _this.handleHttpRsp(rsp); })
            .catch(function (err) { return _this.handleError(err); })
            .subscribe(function (data) {
            if (successCallback) {
                successCallback(data);
            }
        }, function (err) {
            if (errorCallback) {
                errorCallback(err);
            }
        });
    };
    CommonRequestService.prototype.requestDelete = function (url, options, successCallback, errorCallback, notDefaultHttp) {
        var _this = this;
        // const requester = notDefaultHttp ? this.alternativeHttp : this.defaultHttp;
        options = options || {};
        return this.http.request('delete', url, options)
            .map(function (rsp) { return _this.handleHttpRsp(rsp); })
            .catch(function (err) { return _this.handleError(err); })
            .subscribe(function (data) {
            if (successCallback) {
                successCallback(data);
            }
        }, function (err) {
            if (errorCallback) {
                errorCallback(err);
            }
        });
    };
    CommonRequestService.prototype.setParamsPaging = function (params, paging) {
        if (paging.pageSize || paging.pageSize === 0) {
            params.pageSize = paging.pageSize.toString();
        }
        if (paging.pageNumber || paging.pageNumber === 0) {
            params.pageNumber = paging.pageNumber.toString();
        }
        if (paging.rowCount || paging.rowCount === 0) {
            params.rowCount = paging.rowCount.toString();
        }
        // if (paging.pageSize || paging.pageSize === 0) {
        // 	params.set('pageSize', paging.pageSize.toString());
        // }
        // if (paging.pageNumber || paging.pageNumber === 0) {
        // 	params.set('pageNumber', paging.pageNumber.toString());
        // }
        // if (paging.rowCount || paging.rowCount === 0) {
        // 	params.set('rowCount', paging.rowCount.toString());
        // }
    };
    CommonRequestService.prototype.handleLayerNotFoundErr = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, alert('Layer has been updated or deleted. Please refresh.')];
                    case 1:
                        _a.sent();
                        window.open(AppSettings.rootLink + 'azgiv/dashboard', '_self');
                        return [2 /*return*/];
                }
            });
        });
    };
    return CommonRequestService;
}());
export { CommonRequestService };
